var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMex(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 198,
    height: 198,
    viewBox: "0 0 198 198",
    className: "expanded",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "mex",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a45c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001f9c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mex-2",
    x1: 0.5,
    y1: 0.491,
    x2: 0.5,
    y2: 0.009,
    xlinkHref: "#mex"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.237 0.236)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 99,
    cy: 99,
    r: 99,
    transform: "translate(-0.237 -0.236)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(56.084 37.645)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M378.85,152.213l-10.414,48.375H342.182Z",
    transform: "translate(-323.013 -152.213)",
    fillRule: "evenodd",
    fill: "url(#mex)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.4,271.184l-19.166,25.487H295.04l19.169-25.487Z",
    transform: "translate(-295.04 -222.808)",
    fill: "#1a45c2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.314,333.864,367.646,382.24l10.414-48.376Z",
    transform: "translate(-338.123 -260.002)",
    fillRule: "evenodd",
    fill: "url(#mex-2)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMex);
export default __webpack_public_path__ + "static/media/mex.38be89f73c2743d46ff3ecedf6f5f551.svg";
export { ForwardRef as ReactComponent };